export default __webpack_public_path__ + "c3592ea7cb8dbec1f4156a2d7c7ea75d.png";